enum MaterialCostSource {
	COMPANY = 'COMPANY',
	COMPANY_MATERIAL = 'COMPANY_MATERIAL',
	JOB = 'JOB',
	JOB_MATERIAL = 'JOB_MATERIAL',
}

export default MaterialCostSource;
